import apiService from "services/apiService";
import {
  GetLeavePayload,
  LeaveBalanceCheck,
  LeavePayload,
  LeaveResponse,
  UpdatePayload,
} from "./leaveInterface";
import { AxiosResponse } from "axios";

class LeaveManager {
    private url: string;
    constructor() {
        this.url = `api/leave`
    }
  async getLeaveData(
    payload: GetLeavePayload
  ): Promise<AxiosResponse<Array<LeaveResponse>>> {
    const params = new URLSearchParams({
      ...(payload.month && { month: payload.month }),
      ...(payload.email && { email: payload.email }),
      ...(payload.status && { status: payload.status }),
    });

    return await apiService.get(`${this.url}/data/${payload.year}?${params.toString()}`);
  }

  async addLeave(payload: LeavePayload): Promise<AxiosResponse<LeaveResponse>> {
    return await apiService.post(this.url, payload)
  }

  async updateLeave(payload: UpdatePayload): Promise<AxiosResponse<LeaveResponse>> {
    return await apiService.put(`${this.url}/${payload.id}`, payload);
  }

  async deleteLeave(id: number): Promise<AxiosResponse> {
    return await apiService.delete(`${this.url}/${id}`);
  }

  // Balance check for an upcoming-month leave. `fromDate`/`toDate` are ISO
  // date-time strings (both required by the API). Returns the current balance +
  // a human-readable warning to show the user (accrual may change the balance by
  // the time the leave is processed).
  async checkBalance(
    leaveType: string,
    fromDate: string,
    toDate: string,
  ): Promise<AxiosResponse<LeaveBalanceCheck>> {
    const params = new URLSearchParams({ leaveType, fromDate, toDate });
    return await apiService.get(`${this.url}/balance-check?${params.toString()}`);
  }
}

const leaveManager = new LeaveManager();
export default leaveManager;